import moment from 'moment';

//
// This method is a modified version of parseUri 1.2.2. It has been converted to CoffeeScript and converted to ES6!
// the options interface has been removed; the options hash is just inside the method now.
// The original parseUri is (c) Steven Levithan <stevenlevithan.com> and MIT-Licensed.
// http://blog.stevenlevithan.com/archives/parseuri
//
function parseUri(str) {
  const o = {
    strictMode: false,
    key: [
      'source',
      'protocol',
      'authority',
      'userInfo',
      'user',
      'password',
      'host',
      'port',
      'relative',
      'path',
      'directory',
      'file',
      'query',
      'anchor',
    ],
    q: {
      name: 'queryKey',
      parser: /(?:^|&)([^&=]*)=?([^&]*)/g,
    },
    parser: {
      strict:
        // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
        // eslint-disable-next-line no-useless-escape
        /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
      loose:
        // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
        // eslint-disable-next-line no-useless-escape
        /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,
    },
  };

  const m = o.parser[o.strictMode ? 'strict' : 'loose'].exec(str);
  const uri = {};
  let i = 14;

  while (i--) {
    uri[o.key[i]] = m[i] || '';
  }

  uri[o.q.name] = {};
  uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
    if ($1) {
      return (uri[o.q.name][$1] = $2);
    }
  });

  return uri;
}
//
// This is just a convenience method around the above parsing.
//
function domainNameFromUrl(originalUrl) {
  let domainName;
  const parsedUri = parseUri(originalUrl);
  // hostnameElements = parsedUri.host.split(".")
  // domainName = [String(hostnameElements.pop()).toLowerCase(), String(hostnameElements.pop()).toLowerCase()].reverse().join(".")
  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return (domainName = parsedUri.host.replace('www.', ''));
}

function transformToDayCounts(itemsGroupedByDate) {
  const itemsByDay = [];

  const startMoment = moment(
    Aedu.ReduxStore.getState().AnalyticsDashboard.DisplayedDates.start,
  );
  const finishMoment = moment(
    Aedu.ReduxStore.getState().AnalyticsDashboard.DisplayedDates.finish,
  );

  while (startMoment.isBefore(finishMoment.endOf('day'))) {
    const thisDayString = startMoment.format('YYYY-MM-DD');
    const thisDayCount =
      (itemsGroupedByDate[thisDayString] != null
        ? itemsGroupedByDate[thisDayString].length
        : undefined) || 0;
    itemsByDay.push(thisDayCount);
    startMoment.add(1, 'day');
  }

  return itemsByDay;
}

function isCurrentThirtyDays(displayedDates) {
  return (
    moment(new Date(displayedDates.finish)).isSame(moment(), 'day') &&
    displayedDates.dayCount === 30
  );
}

export {
  parseUri,
  domainNameFromUrl,
  transformToDayCounts,
  isCurrentThirtyDays,
};
